
import FeaturesIconsItem from '~/components/product-page/pdp-features/feature-icons-item'
export default {
  components: { FeaturesIconsItem },
  props: {
    product: {
      type: Object,
      default: null,
    },
    wording: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      iconActive: null,
    }
  },
  computed: {
    icons() {
      if (this.product && this.product.icons && this.product.icons.length > 0)
        return this.wording.icons_list.filter((icon) =>
          this.product.icons.includes(icon.key)
        )
      else return []
    },
  },
  mounted() {
    if (this.icons.length > 0) this.iconActive = this.icons[0]
  },
}
